var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM17.5606 9.84615H14.7692V18.1538H17.5606V9.84615ZM15.1762 19.94C14.9049 20.2003 14.7692 20.5243 14.7692 20.912C14.7692 21.2997 14.9049 21.6292 15.1762 21.9006C15.4476 22.172 15.7772 22.3077 16.1649 22.3077C16.5526 22.3077 16.8821 22.172 17.1535 21.9006C17.4249 21.6292 17.5606 21.2997 17.5606 20.912C17.5606 20.5243 17.4249 20.2003 17.1535 19.94C16.8821 19.6797 16.5526 19.5495 16.1649 19.5495C15.7772 19.5495 15.4476 19.6797 15.1762 19.94Z",
    fill: "#D0021B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFailure);
export default __webpack_public_path__ + "static/media/alert-failure.4b345e40.svg";
export { ForwardRef as ReactComponent };